import type React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getUser } from '../utils';
import { PATH } from './PATH';

/**
 * Role gate for the POS sales screen. Sits inside `SecuredRoutes` (so the user is
 * already enrolled + signed in). A `BranchAdmin` can't sell — the API 403s their
 * token on the sale endpoint — so they're redirected to the management shell;
 * everyone else renders the POS.
 */
export const SellerRoute: React.FC = () => {
    if (getUser()?.role === 'BranchAdmin') {
        return <Navigate replace to={PATH.MANAGE} />;
    }
    return <Outlet />;
};
